import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import { getMPPImage } from 'products';
import showTVSheet from 'rangeConfig/shared/features/TVFeature/behaviors/showTVSheet';
import ImageBanner from 'components/ProductSidebar/CategoryWidget/ImageBanner';

const productListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'typeName, designText, communicatedSizeText',
  infoButtonAriaLabel: 'storageone.productListCabinetsTitle',
  mobileCardText: 'communicatedSizeText',
  productCardHoverImage: getMPPImage,
  cluster: [],
  sortOrder: [{ path: 'dimensions.width' }, { path: 'dimensions.height' }],
  behaviors: {
    productClicked: [addProduct, showTVSheet],
    productDropped: [addProduct, showTVSheet]
  },
  categories: [
    {
      id: 'frameWhite',
      categoryTitle: 'designText typeName',
      widgets: [{ component: ImageBanner }],
      products: [
        { path: 'type', value: ProductType.EKET_MEDIA_FRAME },
        { path: 'design', value: ProductDesign.WHITE }
      ]
    },
    {
      id: 'frameDG',
      categoryTitle: 'designText typeName',
      widgets: [{ component: ImageBanner }],
      products: [
        { path: 'type', value: ProductType.EKET_MEDIA_FRAME },
        { path: 'design', value: ProductDesign.DARK_GREY }
      ]
    },
    {
      id: 'frameBWE',
      categoryTitle: 'designText typeName',
      widgets: [{ component: ImageBanner }],
      products: [
        { path: 'type', value: ProductType.EKET_MEDIA_FRAME },
        { path: 'design', value: ProductDesign.BROWN_WALNUT_EFFECT }
      ]
    }
  ]
};

export default productListConfig;
